
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"72","height":"72","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"71","height":"71","rx":"35.5","fill":"url(#paint0_linear)","stroke":"#fff"}}),_c('path',{attrs:{"d":"M21.682 38.36v8L36 54l14.318-7.64v-8L36 46l-14.318-7.64zM36 18L13.5 30 36 42l18.41-9.82V46h4.09V30L36 18z","fill":"#fff"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"36","y1":"0","x2":"36","y2":"72","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#108999"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#175F69"}})])])])
          )
        }
      }
    